import React from 'react';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { Box, Typography } from '@drone-js/core';
import { StringFormatter } from '@agoda/react-handyman';

export interface SummaryInfoTextProps {
    cms: CmsValue;
    label?: string;
    value?: string;
}

const SummaryInfoText: React.FC<SummaryInfoTextProps> = (props) => {
    const { cms, label, value } = props;

    if (!label || !value) {
        return null;
    }
    return (
        <Box pb="8" data-testid="summary-info-text">
            <Typography variant="body-s-strong" tag="span">
                {StringFormatter.format(cms[337158], label)}
            </Typography>
            <Typography variant="body-s" tag="span">
                {value}
            </Typography>
        </Box>
    );
};

SummaryInfoText.displayName = 'InfoText';

export default SummaryInfoText;
